module.exports = __webpack_public_path__ + "img/delivery-courier.c888d7c3.png";